import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import RestaurantForm from '../../components/restaurants/forms/storeForm'
import firebase from '../../config/firebase'

const NewRestaurant = () => {
  const firebaseKey = firebase
    .database()
    .ref()
    .child('restaurants')
    .push().key

  return (
    <div>
      <Segment color="black" style={{ marginBottom: 20 }}>
        <Header size="large">New Restaurant</Header>
        <RestaurantForm firebaseKey={firebaseKey} action="New" />
      </Segment>
    </div>
  )
}

export default NewRestaurant



// WEBPACK FOOTER //
// ./src/containers/restaurants/new.js